// TODO: consider moving this file to talentProfile/exclusivity/
import { WorkLocation } from "../../../../../customer/types/queries";
import { TalentExclusivity } from "../../../../../talents/talentAPI";

type ExclusivityMatchArgs = {
  exclusivity: TalentExclusivity;
  workLocation: WorkLocation;
  resolvedCompanyId: string | null;
};

type ExclusivityCoverageArgs = {
  exclusivities: TalentExclusivity[];
  workLocation: WorkLocation;
  selectedWorkTitleIds: string[];
  resolvedCompanyId: string | null;
};

export const matchesExclusivityTarget = ({
  exclusivity,
  workLocation,
  resolvedCompanyId,
}: ExclusivityMatchArgs): boolean => {
  if (exclusivity.workLocationId) {
    return exclusivity.workLocationId === workLocation.id;
  }

  if (exclusivity.customerOrganizationId) {
    return exclusivity.customerOrganizationId === workLocation.customerOrgId;
  }

  return (
    typeof resolvedCompanyId === "string" &&
    exclusivity.customerCompanyId === resolvedCompanyId
  );
};

export const isSelectionAllowedByExclusivities = ({
  exclusivities,
  workLocation,
  selectedWorkTitleIds,
  resolvedCompanyId,
}: ExclusivityCoverageArgs): boolean => {
  if (!exclusivities.length || !selectedWorkTitleIds.length) {
    return true;
  }

  const matchingTargetExclusivities = exclusivities.filter((exclusivity) =>
    matchesExclusivityTarget({
      exclusivity,
      workLocation,
      resolvedCompanyId,
    }),
  );

  if (
    matchingTargetExclusivities.some(
      (exclusivity) => exclusivity.workTitles.length === 0,
    )
  ) {
    return true;
  }

  const coveredWorkTitleIds = new Set(
    matchingTargetExclusivities.flatMap((exclusivity) =>
      exclusivity.workTitles.map((workTitle) => workTitle.id),
    ),
  );

  return selectedWorkTitleIds.every((workTitleId) =>
    coveredWorkTitleIds.has(workTitleId),
  );
};
